import tippy from 'tippy.js';
import { MEMBERSHIP_TOOLTIP_KLASS } from '../S/constant';
import { $findAll, $qs, $remove, $siblings, $trigger } from 'fxdom/es';
import { pipe } from '@fxts/core';
import { each, head, sel } from 'fxjs/es';
import { getAvailableColors } from '../../../../Creator/Setting/S/fs';
import { GoodsTypeS } from '../../../../GoodsType/S/Function/module/GoodsTypeS';

export const initMembershipInfoTooltips = ($tab_el: HTMLElement, is_mobile: boolean) => {
  pipe(
    $tab_el,
    $findAll(`.${MEMBERSHIP_TOOLTIP_KLASS}`),
    each(($container: HTMLElement) => {
      const $icon = head($siblings('.tooltip-icon', $container));
      tippy($icon, {
        content: $container.outerHTML,
        allowHTML: true,
        offset: [0, 18],
        interactive: true,
        appendTo: document.body,
        placement: is_mobile ? 'bottom-start' : 'top-end',
        animation: 'fade',
        maxWidth: is_mobile ? undefined : 268,
        arrow: false,
        hideOnClick: true,
        trigger: 'click',
        popperOptions: is_mobile
          ? {
              modifiers: [
                {
                  name: 'preventOverflow',
                  options: {
                    padding: 16,
                    boundariesElement: 'viewport',
                  },
                },
              ],
            }
          : undefined,
        onShow(instance) {
          setTimeout(() => {
            instance.hide();
          }, 10000);
        },
        onMount(instance) {
          const wrapper = $qs(`.${MEMBERSHIP_TOOLTIP_KLASS}`);
          const close = () => {
            instance.hide();
            wrapper.removeEventListener('click', close);
          };
          wrapper.addEventListener('click', close);
        },
      });
    }),
    each($remove),
  );
  return $tab_el;
};

// 상품 상세 진입 시 box와 ui상태가 맞지 않는 상황을 방지하기 위한 함수입니다.
export const syncUiByBoxState = (): void => {
  // 셀러가 선택한 색상이 base_product.base_product_colors에 더 이상 존재하지 않을 수 있음.
  const checked_option_el = $qs('.pd-select option:checked');
  if (checked_option_el && !checked_option_el?.value) {
    return;
  }

  const {
    base_product,
    stores_product: {
      goods_type_id,
      _: { store_product_colors },
    },
    product_color: { base_product_color_id, product_faces2, base_product_id },
  } = box.sel('product_detail');

  const base_product_colors = sel('_.base_product_colors', base_product);
  const available_colors = getAvailableColors(base_product_colors, store_product_colors);

  if (GoodsTypeS.isMps(goods_type_id) && !available_colors.length) {
    alert(T('error::This product is out of stock.'));
    return location.replace(`/${T.lang}/${box.sel('domain_name')}`);
  }

  const checked_color_el = $qs('[name="color"]:checked');
  const device_el = $qs('[name="device"]');

  /**
   * 폰케이스 기종 다른 경우 싱크
   */
  if (device_el && Number(device_el.value) !== base_product_id) {
    device_el.value = base_product_id;
    $trigger('change', device_el);

    // 기종이 변경되는 경우 컬러칩도 다시 그려지기 때문에 그냥 return 한다.
    return;
  }

  /**
   * 컬러칩 다른 경우 싱크
   */
  if (
    GoodsTypeS.isNotPod(goods_type_id) ||
    product_faces2.can_not_change_color ||
    Number(checked_color_el?.value) === base_product_color_id
  ) {
    // box color랑 선택된 input에 select된 것이 같으면 그냥 리턴
    return;
  }

  if (checked_color_el) {
    // 선택된 컬러가 존재하면 트리거로 선택해주기
    $trigger('change', checked_color_el);
  }
};
